const config =
    typeof window === "undefined" ? null : window.__COSCRATCH_CONFIG__;

export const DEBUG_MODE = false;

export const getFirebaseConfig = () => {
    const firebase = config?.firebase;
    if (firebase?.apiKey && firebase?.projectId) return firebase;

    if (typeof window !== "undefined")
        throw new Error(
            "Firebase configuration is missing from config.js. Run the installer (npm run setup) to generate it.",
        );

    return null;
};

export const getServerUrl = () => {
    const configured = config?.serverUrl;
    if (configured) return String(configured).trim().replace(/\/+$/, "");

    if (DEBUG_MODE) return "http://localhost:3000";

    if (typeof window === "undefined") return "";
    return window.location.origin;
};
